<template>
    <v-row align="center">
        <v-col>
            <v-select 
                solo 
                dense
                :items="available" 
                v-model="item.app_version" 
                multiple
                :menu-props="{ top: true, offsetY: true }"
                @change="update(item)"
                :hide-details="true"></v-select>
        </v-col>
    </v-row>
</template>

<script>

export default {
    name: 'ABTestControls',
    props: {
        customer: {
            type: Object,
            required: true
        },
        available: {
            type: Array,
            required: true
        }
    },
    data: () => ({
        item: { app_version: [] }
    }),
    beforeUpdate() {
        this.item = this.customer;
    },
    methods: {
        update(item) {
            this.$emit('updated', item);
        }
    },
    watch: {
        customer: {
            immediate: true,
            handler: function(value) {
                this.item = value
            }
        }
    }
}
</script>


<style scoped>
.col { padding: 6px !important; }
.v-input--selection-controls { margin-top: 0; }
</style>